<template lang='slm'>
  form.text-left @submit.prevent='formSubmit'
    template v-if='question'
      button.d-none
      .form-group.p-3.border v-if='question.previousQuestions.length'
        label Предыдущий диалог:
        .mb-2 v-for='q in question.previousQuestions'
          strong.d-block {{ q.question }}
          span {{ q.answer }}
      .form-group
        label Имя
        pre {{ question.name }}
      .form-group
        label Вопрос
        pre {{ question.question }}
      .form-group
        label Ответ
        textarea.form-control v-model='answer' :readonly='readonly'
</template>

<script>
export default {
  name: 'AdminQuestionModalContent',
  data() {
    return {
      question: null,
      answer: '',
      readonly: false,
    };
  },
  methods: {
    formSubmit() {
      this.$parent.confirm();
    },
    beforeShow({ question, readonly }) {
      this.question = this.$_removeImmutabitity(question);
      // eslint-disable-next-line no-underscore-dangle
      delete this.question.__typename;
      this.answer = question.answer || '';
      this.readonly = readonly || false;
    },
  },
  computed: {
    modalContentData() {
      return {
        id: this.question.id,
        answer: this.answer,
        skipSave: this.readonly,
      };
    },
  },
  mounted() {
    this.$on('beforeShow', this.beforeShow);
  },
};
</script>
